<template>
    <h3>Vista para Canales</h3>
</template>

<script>
export default {

}
</script>

<style>

</style>